import React, { Component } from "react";
import Section from "./layouts/Section";
import { WebLink, SiteWide } from "./customComponents";
import { userSelect, allRemoteSettingsSelect } from '../redux/selectors/index';
import { useSelector, useDispatch } from 'react-redux';
import { Images } from "./customComponents";
import parse from 'html-react-parser';
import { mainStyle, mainColor, header, footer, otherColors } from '../utility/styles';
import { useNavigate, useLocation } from 'react-router-dom';



function Term() {

    const site_settings = useSelector(allRemoteSettingsSelect);
    const userData = useSelector(userSelect);
    const navigate = useNavigate();
    const location = useLocation();
    const siteName = site_settings?.site_settings?.sitename || 'Our Platform';


    return (
        <SiteWide id="main" title={"Terms & Conditions"}>
            {/* Hero/Header */}
            <div style={{
                background: 'linear-gradient(135deg, rgba(15,23,42,0.9) 0%, rgba(30,41,59,0.9) 50%, rgba(51,65,85,0.9) 100%)',
                borderBottom: '1px solid rgba(139, 92, 246, 0.25)'
            }}>
                <div className="container" style={{ paddingTop: 36, paddingBottom: 24 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
                        <div>
                            <div style={{
                                fontSize: 24,
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #a78bfa 0%, #ec4899 100%)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                WebkitTextFillColor: 'transparent'
                            }}>Terms & Conditions</div>
                            <div style={{ color: '#94a3b8', marginTop: 6 }}>Please review the terms governing your use of {siteName}.</div>
                        </div>

                        {/* Actions (top) */}
                        <div style={{ display: 'flex', gap: 8 }}>
                            <button
                                onClick={() => navigate(-1)}
                                style={{
                                    padding: '10px 14px',
                                    borderRadius: 10,
                                    border: '1px solid rgba(148,163,184,0.25)',
                                    background: 'transparent',
                                    color: '#e2e8f0',
                                    cursor: 'pointer'
                                }}
                            >Back</button>

                            {userData?.email ? (
                                <button
                                    onClick={() => navigate('/')}
                                    style={{
                                        padding: '10px 14px',
                                        borderRadius: 10,
                                        border: 'none',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: '#fff',
                                        cursor: 'pointer',
                                        boxShadow: '0 10px 25px rgba(102,126,234,0.25)'
                                    }}
                                >Go to Dashboard</button>
                            ) : (
                                <button
                                    onClick={() => navigate('/signup', { state: { from: location?.pathname } })}
                                    style={{
                                        padding: '10px 14px',
                                        borderRadius: 10,
                                        border: 'none',
                                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                        color: '#fff',
                                        cursor: 'pointer',
                                        boxShadow: '0 10px 25px rgba(16,185,129,0.25)'
                                    }}
                                >Create an Account</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="transaction-area" style={{ paddingTop: 24, paddingBottom: 36 }}>
                <div className="container">
                    <div style={{
                        background: otherColors.card2,
                        borderRadius: 16,
                        border: '1px solid rgba(148,163,184,0.18)',
                        overflow: 'hidden'
                    }}>

                        <div style={{ padding: 18, lineHeight: 1.7 }}>
                            <div style={{ color: '#e2e8f0' }}>
                                {parse(site_settings?.site_settings?.term ?? '')}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </SiteWide>
    );

}

export default Term;